import { render, staticRenderFns } from "./logi.vue?vue&type=template&id=2851ffab&scoped=true&"
import script from "./logi.vue?vue&type=script&lang=js&"
export * from "./logi.vue?vue&type=script&lang=js&"
import style0 from "./logi.vue?vue&type=style&index=0&id=2851ffab&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2851ffab",
  null
  
)

export default component.exports